"use client";

import ProductCard from "@/components/ProductCard";
import { getSectionStyle } from "@/utils";
import { useRef } from "react";
import classes from "./PopularProducts.module.css";

import tallBanner from "@/assets/tall.png";
import { useLogicalProductsWithInterceptors } from "@/hooks/useLogicalProducts";
import { getS3ImageUrl } from "@/utils/routes";
import Image from "next/image";
import { ProductRowSkeleton } from "../skeleton";

interface Props {
  dir?: "left" | "right";
  widget?: Widget;
}

const PopularProducts = ({
  dir = "left",

  widget,
  initialProducts,
}: Props & { initialProducts?: ProductItem[] }) => {
  const mainRef = useRef(null);

  const { products, loading, error } = useLogicalProductsWithInterceptors({
    widget,
    ref: mainRef,
    initialProducts,
  });

  const settings = widget?.data?.settings || {};

  return (
    <section
      ref={mainRef}
      className={classes.PopularProducts}
      style={getSectionStyle(settings)}
    >
      <div className="container">
        {loading && (
          <>
            <ProductRowSkeleton />
            <div className="mb-4" />
            <ProductRowSkeleton />
          </>
        )}
        <div className={[classes.contents, classes[dir]].join(" ")}>
          <div className={classes.left}>
            <div className={classes.banner}>
              <Image
                src={getS3ImageUrl(widget?.featuredImage || "") || tallBanner}
                alt="banner"
                layout="fill"
                style={{
                  aspectRatio: 310 / 790,
                  objectFit: "cover",
                }}
                unoptimized={true}
              />
            </div>
          </div>

          <div className={classes.right}>
            <div className={classes.products}>
              {products?.slice(0, 8).map((product) => (
                <ProductCard key={(product.slug || product.id) + "-product-card"} productItem={product} type="sm" />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* {(loading || !isIntersecting) ? (
                <div className="container py-4">
                    <ProductsSectionSkleton />
                </div>
            ) : (
            )} */}
    </section>
  );
};

export default PopularProducts;
